import { createActions } from 'redux-actions'
import type { IItemChanges } from '../Items/IItem'

export const { saveItemChangesWip } = createActions({
  saveItemChangesWip: (itemChanges: IItemChanges) => itemChanges,
})
